import type { QueryKey } from '@tanstack/react-query';

/**
 * Single source of truth for identifying which cached queries contain text atoms nested inside scene objects.
 *
 * Previously this predicate was duplicated 3 times in useEditorTextAtom.ts (lines 117-123, 298-305, 458-464)
 * and separately (with a narrower match) in textAtomCacheUpdaters.ts.
 */
export function isTextAtomBearingQuery(queryKey: QueryKey): boolean {
    if (!Array.isArray(queryKey)) return false;

    // scenes.textAtoms queries — the single text-atom-bearing key shape since the
    // screen-local editorScenesTextAtoms factory was retired onto scenesEntity (ADR 0010)
    if (queryKey[0] === 'scenes' && queryKey[1] === 'textAtoms') return true;

    return false;
}
